import React from 'react';
import styled from 'styled-components';
import video1 from '../assets/video5.mp4';
import video2 from '../assets/video6.mp4';
import video3 from '../assets/video7.mp4';
import video4 from '../assets/video8.mp4';
import video5 from '../assets/video9.mp4';
import video6 from '../assets/video10.mp4';
import video7 from '../assets/video11.mp4';
import video8 from '../assets/video12.mp4';
import video9 from '../assets/video13.mp4';

const ProjectsSection = () => {
  const projects = [
    {
      title: 'Complexo Industrial Solar',
      segment: 'Industrial',
      location: 'Parque fabril no interior paulista',
      highlight: 'Redução expressiva nos custos energéticos.',
      video: video6,
      link: 'https://www.instagram.com/gfsolucoesengenharia?igsh=MTFxYXFmZ2s4YmRqeg==',
    },
    {
      title: 'Usina Comercial Integrada',
      segment: 'Comercial',
      location: 'Centro empresarial',
      highlight: 'Sistema dimensionado para alto consumo.',
      video: video7,
      link: 'https://www.instagram.com/gfsolucoesengenharia?igsh=MTFxYXFmZ2s4YmRqeg==',
    },
    {
      title: 'Solução para Condomínio',
      segment: 'Residencial',
      location: 'Condomínio fechado',
      highlight: 'Eficiência e estética integradas.',
      video: video8,
      link: 'https://www.instagram.com/gfsolucoesengenharia?igsh=MTFxYXFmZ2s4YmRqeg==',
    },
    {
      title: 'Projeto de Expansão Solar',
      segment: 'Industrial',
      location: 'Complexo logístico',
      highlight: 'Ampliação de capacidade instalada.',
      video: video9,
      link: 'https://www.instagram.com/gfsolucoesengenharia?igsh=MTFxYXFmZ2s4YmRqeg==',
    },
    {
      title: 'Campus Universitário',
      segment: 'Educacional',
      location: 'Faculdade parceira',
      highlight: 'Energia limpa para pesquisa e ensino.',
      video: video1,
      link: 'https://www.instagram.com/gfsolucoesengenharia?igsh=MTFxYXFmZ2s4YmRqeg==',
    },
    {
      title: 'Centro Comercial Solar',
      segment: 'Comercial',
      location: 'Galeria de lojas',
      highlight: 'Economia imediata na conta de energia.',
      video: video5,
      link: 'https://www.instagram.com/gfsolucoesengenharia?igsh=MTFxYXFmZ2s4YmRqeg==',
    },
    {
      title: 'Rede de Clínicas',
      segment: 'Saúde',
      location: 'Unidades urbanas',
      highlight: 'Operação 24/7 com estabilidade energética.',
      video: video2,
      link: 'https://www.instagram.com/gfsolucoesengenharia?igsh=MTFxYXFmZ2s4YmRqeg==',
    },
    {
      title: 'Cobertura Fotovoltaica',
      segment: 'Industrial',
      location: 'Parque operacional',
      highlight: 'Geração máxima em áreas estratégicas.',
      video: video3,
      link: 'https://www.instagram.com/gfsolucoesengenharia?igsh=MTFxYXFmZ2s4YmRqeg==',
    },
    {
      title: 'Projeto Agro Solar',
      segment: 'Agronegócio',
      location: 'Fazenda produtiva',
      highlight: 'Autonomia energética no campo.',
      video: video4,
      link: 'https://www.instagram.com/gfsolucoesengenharia?igsh=MTFxYXFmZ2s4YmRqeg==',
    }
  ];

  return (
    <SectionContainer>
      <ContentHeader>
        <ProjectsEyebrow>Projetos realizados</ProjectsEyebrow>
        <ProjectsTitle>Energia solar aplicada na prática</ProjectsTitle>
        <ProjectsSubtitle>
          Conheça alguns dos projetos que já entregamos. Cada instalação é pensada para gerar eficiência,
          economia e sustentabilidade para nossos clientes.
        </ProjectsSubtitle>
      </ContentHeader>
      <ProjectsGrid>
        {projects.map((project) => (
          <ProjectCard key={project.title}>
            <MediaWrapper>
              <ProjectVideo
                src={project.video}
                autoPlay
                muted
                loop
                playsInline
                aria-label={`Vídeo do ${project.title}`}
              />
              <ProjectBadge>{project.segment}</ProjectBadge>
            </MediaWrapper>
            <ProjectContent>
              <ProjectTitle>{project.title}</ProjectTitle>
              <ProjectLocation>{project.location}</ProjectLocation>
              <ProjectDescription>{project.highlight}</ProjectDescription>
              <ViewButton
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver projeto no Instagram
              </ViewButton>
            </ProjectContent>
          </ProjectCard>
        ))}
      </ProjectsGrid>
      <ProjectsFooter>
        <FooterText>Veja mais detalhes e bastidores dos projetos no nosso Instagram.</FooterText>
        <FooterLink
          href="https://www.instagram.com/gfsolucoesengenharia/"
          target="_blank"
          rel="noopener noreferrer"
        >
          @gfsolucoesengenharia
        </FooterLink>
      </ProjectsFooter>
    </SectionContainer>
  );
};

export default ProjectsSection;

// Styled Components permanecem iguais


// Styled Components

const SectionContainer = styled.section`
  padding: 100px 20px;
  position: relative;
  width: 100%;
  overflow: hidden;
  background: radial-gradient(circle at top, rgba(255, 255, 255, 0.05), transparent 65%),
    #0b0f1a;

  @media (min-width: 900px) {
    padding: 140px 20px;
  }
`;

const ContentHeader = styled.div`
  max-width: 980px;
  margin: 0 auto 60px;
  text-align: center;
`;

const ProjectsEyebrow = styled.span`
  display: inline-flex;
  padding: 8px 18px;
  border-radius: 999px;
  background: rgba(255, 199, 0, 0.15);
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 0.75rem;
`;

const ProjectsTitle = styled.h2`
  font-size: clamp(2rem, 3vw, 3.25rem);
  margin: 16px 0 12px;
  color: #ffffff;
`;

const ProjectsSubtitle = styled.p`
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.6;
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 28px;
  max-width: 1200px;
  margin: 0 auto;
`;

const ProjectCard = styled.article`
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 24px 60px rgba(5, 9, 21, 0.45);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 30px 80px rgba(5, 9, 21, 0.6);
  }
`;

const MediaWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
`;

const ProjectVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: saturate(1.2);
  transition: transform 0.4s ease;

  ${ProjectCard}:hover & {
    transform: scale(1.05);
  }
`;

const ProjectBadge = styled.span`
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(11, 15, 26, 0.85);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.03em;
`;

const ProjectContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ProjectTitle = styled.h3`
  font-size: 1.3rem;
  color: #ffffff;
  margin: 0;
`;

const ProjectLocation = styled.span`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
`;

const ProjectDescription = styled.p`
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.75);
  margin: 0 0 8px;
  line-height: 1.5;
`;

const ViewButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
  padding: 10px 16px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: #0b0f1a;
  text-decoration: none;
  border-radius: 10px;
  font-weight: 600;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(255, 199, 0, 0.25);
  }
`;

const ProjectsFooter = styled.div`
  margin-top: 60px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FooterText = styled.p`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
`;

const FooterLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
  text-decoration: none;
`;
